<template>
  <!-- deprecated -->
  <v-snackbar
    v-touch="{
      down: handleSnackbarClose,
    }"
    class="snackbar-notification"
    :class="{ 'snackbar-notification_dialog': upper }"
    :timeout="snackbarTimeout"
    :value="value"
    color="text"
    @input="handleSnackbarToggle"
  >
    <span class="text-body-2">
      {{ message }}
    </span>

    <template
      v-if="actionText"
      #action="{ attrs }"
    >
      <v-btn
        v-bind="attrs"
        color="primary"
        text
        @click="handleAction"
      >
        {{ actionText }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { TIMEOUT } from './constants'

export default {
  name: 'SnackbarNotification',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    upper: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    actionText: {
      type: String,
      default: '',
    },
    handleAction: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    snackbarTimeout() {
      return this.actionText ? TIMEOUT.withAction : TIMEOUT.withoutAction
    },
  },
  methods: {
    handleSnackbarClose() {
      this.$emit('change', false)
    },
    handleSnackbarToggle(value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style>
#app .snackbar-notification {
  inset: 0;
  height: initial;
}

#app .snackbar-notification .v-snack__wrapper {
  min-width: 304px;
  width: auto;
}

#app .snackbar-notification.snackbar-notification_dialog .v-snack__wrapper {
  bottom: 56px;
}
</style>
